import { render, staticRenderFns } from "./NoticeReceiver.vue?vue&type=template&id=0a13dcb8&scoped=true&"
import script from "./NoticeReceiver.vue?vue&type=script&lang=js&"
export * from "./NoticeReceiver.vue?vue&type=script&lang=js&"
import style0 from "./NoticeReceiver.vue?vue&type=style&index=0&id=0a13dcb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a13dcb8",
  null
  
)

export default component.exports